import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const ProtectedRoute = ({ children, role }) => {
  const location = useLocation();
  const { isLoggedIn, userRole, loading } = useAuth();

  // Show loading while checking auth
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-white">Loading...</div>
      </div>
    );
  }

  // Check if user is logged in
  if (!isLoggedIn) {
    // Redirect to signin with return URL
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  // Check role-based access
  if (role === "staff" && userRole !== "admin") {
    // Redirect unauthorized users to home
    return <Navigate to="/" replace />;
  }

  // Note: Removed admin redirect from player routes - admins can access casino interface

  return children;
};

export default ProtectedRoute;
